<template>
  <div :class="$style.container">
    <!-- -------------- -->
    <!-- PROFILE TOGGLE -->
    <!-- -------------- -->

    <div :class="$style.header">
      <NsMinimalHeaderProfileToggle
        compact
        :dropdown-open="dropdownOpen"
        :greeting="profileTranslations.greeting"
        :sign-in-label="profileTranslations.signIn"
        :sign-up-label="profileTranslations.signUp"
        @toggle="handleDropdownToggle"
      />
      <!-- CLOSE BUTTON -->
      <div :class="$style.closeButton" @click="handleCloseClick">
        <NsIcon
          :class="$style.closeIcon"
          icon-name="icon-close-24"
          size="custom"
          data-testid="profileDropdownMobileClose"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SitesSessionStorageService } from "@nuskin/ns-util";
import { NsIcon } from "@nuskin/design-components";

import NsMinimalHeaderProfileToggle from "./NsMinimalHeaderProfileToggle.vue";

const PROFILE_CLOSED = "profileClosed";
export default {
  name: "NsMinimalHeaderProfileDropdown",
  components: {
    NsIcon,
    NsMinimalHeaderProfileToggle
  },
  props: {
    /**
     * List of potential navigation links
     */
    profileMenu: {
      type: Array,
      default: () => []
    },
    /**
    /**
     * The url where signout link takes you
     */
    signOutUrl: {
      type: String,
      default: ""
    },
    /**
     * The url where signup link takes you
     */
    signUpUrl: {
      type: String,
      default: ""
    },
    /**
     * Translations for component
     * Required keys: id, greeting, newCustomerLabel,
     * signUpTodayLabel, signIn, signOut, signUp
     */
    translations: {
      type: Object,
      default: () => ({})
    },
    profileTranslations: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    dropdownOpen: !SitesSessionStorageService.getItem(PROFILE_CLOSED)
  }),
  methods: {
    handleCloseClick() {
      this.$emit("close-drawer");
    },
    handleDropdownToggle() {
      this.dropdownOpen = !this.dropdownOpen;
      SitesSessionStorageService.removeItem(PROFILE_CLOSED);
      SitesSessionStorageService.writeItem(PROFILE_CLOSED, !this.dropdownOpen);
    }
  }
};
</script>

<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use '~@nuskin/ns-core-styles/src/scss/typographyVariables';

.container,
.container * {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.container {
  border-radius: 0px;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}

.header {
  display: flex;
}

.closeButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  cursor: pointer;

  // nested for specificity
  .closeIcon {
    width: 14px;
    height: 14px;
    color: map.get(colors.$themeColors, color-interactive-7);
  }
}
</style>
